import { ConversationMessageChunkResponse } from './dto/response/conversation-message-chunk.response';
import { ChunkStore } from './recruiter-agent.toolkit-api';

export type SSEMessageType = {
  id?: string;
  data?: string;
}

export const isChunkResponse = (
  message: unknown,
): message is ConversationMessageChunkResponse => {
  return typeof message === 'object' && message !== null && 'chunkOrder' in message;
};
// Parse SSE message
export const parseSSEMessage = (rawMessage: string): SSEMessageType => {
  const result: SSEMessageType = {};

  rawMessage
    .split('\n')
    .filter((line) => line.trim())
    .forEach((line) => {
      if (line.startsWith('id: ')) {
        result.id = line.slice(4);
      } else if (line.startsWith('data: ')) {
        result.data = line.slice(6);
      }
    });

  return result;
};

export const getAccumulatedMessage = (chunks: ChunkStore): string => {
  return Object.values(chunks)
    .sort((a, b) => a.chunkOrder - b.chunkOrder)
    .map((chunk) => chunk.message)
    .join('');
};
